/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        'name': '规则',
        'type': 'module-name'
    },
    {
        'key': 'property_data',
        'name': '属性',
        'type': 'custom',
        'content': [{
                'key': 'icon_url',
                'name': '图片样式',
                'type': 'choose-photo',
                'memo': '建议尺寸：160px*60px'
            },
            {
                'key': 'width',
                'name': '图片宽',
                'type': 'text'
            },
            {
                'key': 'url',
                'name': '跳转地址',
                'type': 'text'
            },
            {
                'key': 'right',
                'name': '右',
                'type': 'text'
            },
            {
                'key': 'top',
                'name': '上',
                'type': 'text'
            },
        ],
    },
];

export default config